import { Answer } from '../../models/Answer'
import {
  DownOutlined,
  FileOutlined,
  LinkOutlined,
  UpOutlined,
} from '@ant-design/icons'
import { useAppSelector } from '../../store/hooks'
import { SBRMType } from '../../modules/sbrm/SBRMModel'
import { selectAnswersByIds } from '../../store/AnswerReducer'
import { Actions } from '../../modules/sbrm/components/Actions'
import { List, Space, Tag, Tooltip, Typography } from 'antd'
import { Analytics } from './Analytics'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { useState } from 'react'

const { Text, Paragraph } = Typography

interface Props {
  answer: Answer
  isEditing: boolean
}

export const AnswerItem = ({ answer, isEditing }: Props) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <Space className="w-full space-between wrap-on-mobile" size={10}>
      <Space>
        <Tag>{answer.percentage + '%'}</Tag>
        <Paragraph
          style={{ margin: 0 }}
          ellipsis={{
            rows: 2,
            expandable: 'collapsible',
            expanded,
            symbol: expanded ? <UpOutlined /> : <DownOutlined />,
            onExpand: (_, info) => setExpanded(info.expanded),
          }}
        >
          {answer.message}
        </Paragraph>
        {/* Buttons count */}
        {answer.buttons && answer.buttons.length > 0 && (
          <Tooltip
            title={i18n.t(
              LocalizationKeys.Component.Answer.List.ButtonInteractions
            )}
          >
            <Tag icon={<LinkOutlined />}> {answer.buttons?.length}</Tag>
          </Tooltip>
        )}
        {/* Attachments count */}
        {answer.attachments && answer.attachments.length > 0 && (
          <Tooltip
            title={i18n.t(LocalizationKeys.Component.Answer.List.Attachments)}
          >
            <Tag icon={<FileOutlined />}>{answer.attachments.length}</Tag>
          </Tooltip>
        )}
      </Space>
      <Space className={`gleap-answer-actions-${answer.id}`}>
        {isEditing && (
          <Actions
            entity={SBRMType.answer}
            actions={['update', 'delete']}
            entityId={answer.id}
          />
        )}

        {!isEditing && <Analytics id={answer.id} />}
      </Space>
    </Space>
  )
}

export type AnswerItemType = { Item: typeof AnswerItem }
